import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyFormatter',
})
@Injectable({
  providedIn: 'root'
})
export class CurrencyFormatterPipe implements PipeTransform {
  public forceDecimals: boolean = false;
  public amount: number;
  public currencyType: string;
  public formatter: Intl.NumberFormat;

  public transform(amount: number, currencyType: string, excludeDecimals: boolean = false): any {
    this.formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: excludeDecimals ? 0 : 2,
    });
    this.amount = amount;
    this.currencyType = currencyType;
    if (!amount) {
      let amt = excludeDecimals ?  Math.round(amount) : amount;
      return this.getCurrencySymbol() + amt;
    } else {
      let amt = excludeDecimals ?  Math.round(amount) : amount;
      return this.toClientString(amt);
    }
  }

  getCurrencySymbol(): string {
    let symbol: string = '';

    switch (this.currencyType) {
      case 'USD':
      case 'CAD':
        symbol = '$';
        break;
      default:
        symbol = '';
    }

    return symbol;
  }
  toClientString(amount): string {
    amount = this.formatter.format(
      amount.toString().replace(/\,/g, '') //formatter chokes on commas, so we have to remove them- they will be added afterwards by formatter himself
    );
    return amount;
  }
}
